module.exports = __webpack_public_path__ + "img/boy.a5d3f503.svg";